export const checkTextClamped = (ref: React.RefObject<HTMLParagraphElement>) => {
  return ref?.current && ref?.current?.scrollHeight > ref?.current?.clientHeight;
};
